module.exports = __webpack_public_path__ + "static/media/users.a4fb8183.svg";